import { render, staticRenderFns } from "./InceptionAssessmentAnnotationWrapper.vue?vue&type=template&id=c32ffcd4&scoped=true"
import script from "./InceptionAssessmentAnnotationWrapper.vue?vue&type=script&lang=ts"
export * from "./InceptionAssessmentAnnotationWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32ffcd4",
  null
  
)

export default component.exports